import React from 'react';

type SdgHeaderProps = {
  headline?: string;
  introText?: string;
};

const SdgHeader = ({ headline = '', introText = '' }: SdgHeaderProps): JSX.Element => {
  return (
    <>
      <h2 className="hl-2">{headline}</h2>
      <div className="sdg-header-text" dangerouslySetInnerHTML={{__html: introText}} />
    </>
  );
};

export default SdgHeader;
